import { render, staticRenderFns } from "./Scientific_field.vue?vue&type=template&id=8ab4648c&scoped=true"
import script from "./Scientific_field.vue?vue&type=script&lang=js"
export * from "./Scientific_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab4648c",
  null
  
)

export default component.exports